import React from 'react'
import CustomDialog from '../CustomDialog'
import { makeStyles } from '@material-ui/core/styles'
import { useFormik } from 'formik'
import * as yup from 'yup'
import { Box, MenuItem, TextField } from '@material-ui/core'
import AppButton from '../AppButton'

const useStyles = makeStyles((theme) => ({
  paper: {
    maxHeight: '200px',
    overflowY: 'auto',

    '&::-webkit-scrollbar': {
      width: '5px'
    },

    '&::-webkit-scrollbar-thumb': {
      borderRadius: '3px',
      backgroundColor: '#c3c3c3',
      width: '5px'
    }
  },
  input: {
    '@media (min-width: 3000px)': {
      '& svg': {
        top: 'calc(50% - 25px)'
      }
    }
  }
}))

const validationSchema = yup.object({
  category: yup
    .string('Select category')
    .required('Category is required'),
})
function Contact(props) {
  const classes = useStyles()
  const formik = useFormik({
    initialValues: {
      category: '',
      message: '',
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => {
      resetForm({ values: '' })
    },
  })
  const renderContent = () => {
    return (
      <>
        <div>Select a category and write your message to our customer support. We will get back to you shortly.</div>
        <form onSubmit={formik.handleSubmit}>
          <Box my={5}>
            <TextField
              label="Category"
              select
              name="category"
              fullWidth
              value={formik.values.category}
              onChange={formik.handleChange}
              InputProps={{
                classes: { root: classes.input }
              }}
              SelectProps={{
                MenuProps: {
                  classes: { paper: classes.paper },
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left"
                  },
                  getContentAnchorEl: null
                }
              }}
              error={formik.touched.category && Boolean(formik.errors.category)}
              helperText={formik.touched.category && formik.errors.category}
            >
              <MenuItem value="program">Program Related</MenuItem>
              <MenuItem value="account">Account Related</MenuItem>
              <MenuItem value="event">Event Related</MenuItem>
              <MenuItem value="other">Other</MenuItem>
            </TextField>
          </Box>
          <Box my={5}>
            <TextField
              label="Message"
              name="message"
              multiline
              fullWidth
              maxRows={4}
              variant="outlined"
              value={formik.values.message}
              onChange={formik.handleChange}
              error={formik.touched.message && Boolean(formik.errors.message)}
              helperText={formik.touched.message && formik.errors.message}
            />
          </Box>
          <div>
            <span className={''} ><AppButton type="submit" text="Submit" /></span>
          </div>
        </form>
      </>
    )
  }
  return (
    <CustomDialog open={props.open} handleClose={() => { formik.resetForm(); props.handleClose() }} title={'Contact Support'} content={renderContent()} />
  )
}

export default Contact